import React, { Component } from "react";
import {Icon, Rate} from 'antd'
import TerrainStars from './TerrainStars'

const {Link} = require("react-router")


class TerrainLocation extends Component {

    constructor(props) {
        super(props)
        this.location = {
            "resort_name": "253 Mancreek Resort",
            "address_line1": " 253 scottland av",
            "county": "albanyt",
            "postalcode": 12193,
            "market_code": "NAMER",
            "country": "usa",
            "region_desc_en": [
                "United States",
                "Coastal Mid Atlantic"
            ],
            "state": "NY",
        }
    }
    render() {
        const ars = [];
        let svrstars = {
            "sv_rating_no": 5,
            "color": "#e8a01899"
        }
        console.log('############### this.props.svrlocation ****************')
        console.log(this.props.svrlocation)






        return (

      
        
            <header className="svr-header2" style={{paddingBottom:"5px"}}>
              
                <p className="m-para-text-first" style={{paddingTop:"20px"}}>
                    <span> 
                        <text className="svr-hotel-name"  style={{fontSize:"1.5.em", paddingRight:"10px",color:"rgb(208,156,31)"}}>{this.props.svrlocation.resort_name}</text>
        
                        <Icon  style={{ color:"rgb(215, 125, 10)" , fontSize:"20px" }} type="slack-square" theme="filled" />
                    </span>
                    
                    <span className="ter-l2 svr-hotel-location" style={{marginTop:"10px", marginBottom:"7px"}}>
                        <text style={{fontSize:"15px", color:"rgb(132, 115, 97)", fontWeight:"400", paddingRight:"15px"}}>
                        {this.props.svrlocation.address_line1}, {this.props.svrlocation.county}, {this.props.svrlocation.postalcode} , {this.props.svrlocation.country} 
                        </text>
                        <Icon  style={{ color: "rgb(7, 115, 29)", fontSize:"20px" }} type="environment" theme="filled" />
                        <text style={{fontSize:"16px", color:"rgb(18, 85, 219)", paddingLeft:"10px",fontWeight:"420"}}>Excellent2- Shown On Map</text> 
                    </span>
                        
                    <span style={{fontSize: "12px"}} style={{marginTop:"10px",display:"block", marginBottom:"7px"}} > 
                       
                        <text style={{fontSize:"12px", color:"rgb(129, 133, 142)",paddingRight:"10px", paddingLeft:"0px",fontWeight:"400"}}>{this.props.svrlocation["num_reviews"]}  reviews</text>
                        <Icon  style={{ color: '#eb2f96' }} type="car" theme="filled" />
                        
                        <text style={{fontSize:"12px", color:"rgb(129, 133, 142)", paddingLeft:"10px",fontWeight:"420"}}>{this.props.svrlocation.nearest_airport_distance_mi_lvl}  miles from {this.props.svrlocation.en_nearest_airports_lvl} Airport,SV</text>
                    </span>
                    <span style={{fontSize: "18px"}} > 
                        <Icon  style={{ color: '#eb2f96' }} type="dingtalk-square" theme="filled" />
                        <a href={`${this.props.svrlocation.web}`}><text style={{fontSize:"16px", color:"rgb(18, 85, 219)", paddingLeft:"10px",fontWeight:"420"}}>HoteSV Website</text></a> 
                       {/* 
                       <text style={{fontSize:"16px", color:"rgb(18, 85, 219)", paddingLeft:"10px",fontWeight:"420"}}>HoteSV2 Website</text>

                       */}
                                            </span>
                    
                </p>

            </header>
        )
    }

}

export default TerrainLocation;